import GlobalHead from '../../templates/layout/head';
import UnifiedSearch from '../../templates/unified-search';

import type { HeadProps } from 'gatsby';

export const Head = ({
  location,
}: HeadProps) => {
  const seo = {
    canonical: '',
    metaRobotsNofollow: 'nofollow',
    metaRobotsNoindex: 'noindex',
    title: 'Search | Klaviyo',
  } as const;

  return (
    <GlobalHead
      pathname={location.pathname}
      seo={seo}
    />
  );
};

export default UnifiedSearch;
